import { ReactNode, useMemo } from "react"

import { twMerge } from "tailwind-merge"

import { useFieldContext } from "./FieldProvider"

export type FieldHintProps = {
  className?: string
  children?: ReactNode
}

export function FieldHint(props: FieldHintProps) {
  const { className, children: children_ } = props

  const fieldContext = useFieldContext()
  const children = useMemo(() => children_ ?? fieldContext?.hint, [children_, fieldContext?.hint])

  return (
    <>
      {typeof children === "string" ? (
        <small className={twMerge("text-xs text-gray-500", className)}>{children}</small>
      ) : (
        <>{children}</>
      )}
    </>
  )
}
